<script setup lang="ts">
defineProps<{ url: string }>()
</script>

<template>
  <iframe
    :src="url"
    :allowfullscreen="true"
    title="PDF Viewer"
    width="100%"
    height="100%"
    class="flex grow size-full"
  />
</template>
